import {OPEN_CLOSE_REALITY_CHECK_MODAL} from '../constants/actionTypes';

export function openCloseRealityCheckModal(betsToPlace) {
    let notificationDismissible = (betsToPlace.length == 0) ? true : false;
    return {
        type: OPEN_CLOSE_REALITY_CHECK_MODAL,
        isNotificationDismissible: notificationDismissible,
        betsToPlaceAfterRealityCheck: betsToPlace
    }
}





// WEBPACK FOOTER //
// ./src/actions/realityCheckModalAction.js